// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.deleteChip {
  position: absolute;
  bottom: 0;
  right: 0;
  height: 30px;
  width: 30px;
  border-radius: 20px;
  margin: 0;
  text-align: center;
}

ion-label {
  display: block;
}

.no-padding-input {
  padding-bottom: 0 !important;
}

ion-card ion-card-header {
  display: flex;
  align-items: center;
}
ion-card ion-card-header ion-card-title {
  flex: auto;
  margin-top: 0;
  font-size: 16px;
  font-weight: bold;
}

.check {
  color: var(--ion-color-success-shade);
  font-size: 20px;
  margin-right: 5px;
}

.toggle {
  color: var(--ion-color-primary);
  font-size: 28px;
}

.pictures {
  min-height: 100px;
}

.photoCountChip {
  position: absolute;
  top: -4px;
  right: -3px;
  height: 20px;
  width: 20px;
  background: var(--ion-color-dark) !important;
  border-radius: 20px;
  border: var(--ion-color-light) solid 1px;
  margin: 0;
  color: var(--ion-color-tertiary) !important;
  text-align: center;
  font-weight: bold;
}

.center {
  margin: auto;
}

.validation-button {
  float: right;
  margin-bottom: 15px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/material-line.component.scss","webpack://./src/app/components/material-line-departure-matqt-conso/material-line-departure-matqt-conso.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;ACCJ;;ADEA;EACI,cAAA;ACCJ;;ADEA;EACI,4BAAA;ACCJ;;ADGI;EACI,aAAA;EACA,mBAAA;ACAR;ADEQ;EACI,UAAA;EACA,aAAA;EACA,eAAA;EACA,iBAAA;ACAZ;;ADKA;EACI,qCAAA;EACA,eAAA;EACA,iBAAA;ACFJ;;ADKA;EACI,+BAAA;EACA,eAAA;ACFJ;;ADKA;EACI,iBAAA;ACFJ;;ADKA;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,4CAAA;EACA,mBAAA;EACA,wCAAA;EACA,SAAA;EACA,2CAAA;EACA,kBAAA;EACA,iBAAA;ACFJ;;ADKA;EACI,YAAA;ACFJ;;ADKA;EACI,YAAA;EACA,mBAAA;ACFJ","sourcesContent":[".deleteChip {\r\n    position: absolute;\r\n    bottom: 0;\r\n    right: 0;\r\n    height: 30px;\r\n    width: 30px;\r\n    border-radius: 20px;\r\n    margin: 0;\r\n    text-align: center;\r\n}\r\n\r\nion-label {\r\n    display: block\r\n}\r\n\r\n.no-padding-input {\r\n    padding-bottom: 0 !important;\r\n}\r\n\r\nion-card {\r\n    ion-card-header {\r\n        display: flex;\r\n        align-items: center;\r\n\r\n        ion-card-title {\r\n            flex: auto;\r\n            margin-top: 0;\r\n            font-size: 16px;\r\n            font-weight: bold;\r\n        }\r\n    }\r\n}\r\n\r\n.check {\r\n    color: var(--ion-color-success-shade);\r\n    font-size: 20px;\r\n    margin-right: 5px;\r\n}\r\n\r\n.toggle {\r\n    color: var(--ion-color-primary);\r\n    font-size: 28px;\r\n}\r\n\r\n.pictures {\r\n    min-height: 100px;\r\n}\r\n\r\n.photoCountChip {\r\n    position: absolute;\r\n    top: -4px;\r\n    right: -3px;\r\n    height: 20px;\r\n    width: 20px;\r\n    background: var(--ion-color-dark) !important;\r\n    border-radius: 20px;\r\n    border: var(--ion-color-light) solid 1px;\r\n    margin: 0;\r\n    color: var(--ion-color-tertiary) !important;\r\n    text-align: center;\r\n    font-weight: bold;\r\n}\r\n\r\n.center {\r\n    margin: auto;\r\n}\r\n\r\n.validation-button {\r\n    float: right;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n",".deleteChip {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  height: 30px;\n  width: 30px;\n  border-radius: 20px;\n  margin: 0;\n  text-align: center;\n}\n\nion-label {\n  display: block;\n}\n\n.no-padding-input {\n  padding-bottom: 0 !important;\n}\n\nion-card ion-card-header {\n  display: flex;\n  align-items: center;\n}\nion-card ion-card-header ion-card-title {\n  flex: auto;\n  margin-top: 0;\n  font-size: 16px;\n  font-weight: bold;\n}\n\n.check {\n  color: var(--ion-color-success-shade);\n  font-size: 20px;\n  margin-right: 5px;\n}\n\n.toggle {\n  color: var(--ion-color-primary);\n  font-size: 28px;\n}\n\n.pictures {\n  min-height: 100px;\n}\n\n.photoCountChip {\n  position: absolute;\n  top: -4px;\n  right: -3px;\n  height: 20px;\n  width: 20px;\n  background: var(--ion-color-dark) !important;\n  border-radius: 20px;\n  border: var(--ion-color-light) solid 1px;\n  margin: 0;\n  color: var(--ion-color-tertiary) !important;\n  text-align: center;\n  font-weight: bold;\n}\n\n.center {\n  margin: auto;\n}\n\n.validation-button {\n  float: right;\n  margin-bottom: 15px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
